import React from "react"
import { graphql, useStaticQuery, withPrefix } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import Button from "components/Button"

import { useLocale } from "context/locale"

import DownloadIconBlack from "icons/download-black.svg"

import StyledStrategyTiles from "./styles"

const StrategyTiles = () => {
  const { t } = useLocale()

  const data = useStaticQuery(
    graphql`
      query {
        bg_1: file(relativePath: { eq: "refresh/525x300_KAFELEK_1.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        bg_2: file(relativePath: { eq: "refresh/525x300_KAFELEK_2.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        bg_3: file(relativePath: { eq: "refresh/525x300_KAFELEK_3.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        bg_4: file(relativePath: { eq: "refresh/525x300_KAFELEK_4.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        people: file(relativePath: { eq: "refresh/500x300_LUDZIE.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        product: file(relativePath: { eq: "refresh/500x300_PRODUKT.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        planet: file(relativePath: { eq: "refresh/525x300_PLANETA.jpg" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  return (
    <StyledStrategyTiles>
      <div className="main-container">
        <div className="row">
          <BackgroundImage
            className="item"
            fluid={data.people.childImageSharp.fluid}
            backgroundColor={`#fff`}
            style={{ backgroundPosition: "center center" }}
          >
            <h2>{t("PEOPLE")}</h2>
            <div className="item__inner">
              <div>
                <h4>{t("PEOPLE")}</h4>
                <h5>#people</h5>
                <p>
                  {t(
                    "Our actions are guided by inspiration and care, which we express by empowering ourselves and others to improve physical and mental health."
                  )}
                </p>
              </div>
              {/* <div>
                <p>{t("Learn more")}:</p>
                <a
                  href={withPrefix(t("our_strategy_file"))}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DownloadIconBlack /> {`${t("Strategy")}.pdf`}
                </a>
              </div> */}
            </div>
          </BackgroundImage>
          <BackgroundImage
            className="item"
            fluid={data.planet.childImageSharp.fluid}
            backgroundColor={`#fff`}
            style={{ backgroundPosition: "center center" }}
          >
            <h2>{t("PLANET")}</h2>
            <div className="item__inner">
              <div>
                <h4>{t("PLANET")}</h4>
                <h5>#planet</h5>
                <p>
                  {t(
                    "We understand the impact of the fashion industry on the environment and take responsibility for our actions."
                  )}
                </p>
              </div>
              {/* <div>
                <p>{t("Learn more")}:</p>
                <a
                  href={withPrefix(t("our_strategy_file"))}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DownloadIconBlack /> {`${t("Strategy")}.pdf`}
                </a>
              </div> */}
            </div>
          </BackgroundImage>
          <BackgroundImage
            className="item"
            fluid={data.product.childImageSharp.fluid}
            backgroundColor={`#fff`}
            style={{ backgroundPosition: "center center" }}
          >
            <h2>{t("PRODUCT")}</h2>
            <div className="item__inner">
              <div>
                <h4>{t("PRODUCT")}</h4>
                <h5>#product</h5>
                <p>
                  {t(
                    "We are transitioning towards circularity, implementing a circular economy."
                  )}
                </p>
              </div>
              {/* <div>
                <p>{t("Learn more")}:</p>
                <a
                  href={withPrefix(t("our_strategy_file"))}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DownloadIconBlack /> {`${t("Strategy")}.pdf`}
                </a>
              </div> */}
            </div>
          </BackgroundImage>
        </div>
        {/* <div className="cta">
          <Button
            text={t("First version of the strategy")}
            as="link-out"
            href="/4Fchange_strategia_ECO.pdf"
            variant="download-dark"
          />
        </div> */}
      </div>
    </StyledStrategyTiles>
  )
}

export default StrategyTiles
